var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_4023)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.3214 48.8255L94.1331 39.8276C95.3508 38.5864 96.1461 36.2498 97.2145 35.0192C98.2829 33.7885 96.7751 32.6197 96.7751 32.6197L92.5878 28.9844L91.9325 28.4155L87.7451 24.7802C87.7451 24.7802 86.3761 23.4515 85.3077 24.6822C84.2393 25.9128 82.0376 27.0284 80.9798 28.4083L73.1819 37.3903C73.1819 37.3903 71.3743 38.9882 73.0045 40.4034L77.8471 44.6076C78.2467 44.9545 78.5024 45.1765 78.5024 45.1765L83.345 49.3807C84.9911 50.8098 86.3033 48.7818 86.3033 48.7818L86.3214 48.8255Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1014_4023",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 39,
    width: 53,
    height: 57
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2787 50.1394L72.1642 39.6221L32.4951 85.3152L44.6096 95.8326L84.2787 50.1394Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1014_4023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4316 40.5775L81.8882 40.1057C79.249 37.8145 75.2521 38.0965 72.9608 40.7357L38.6337 80.2757C36.3424 82.9149 36.6245 86.9118 39.2637 89.2031L39.8071 89.6748C42.4463 91.9661 46.4432 91.684 48.7344 89.0448L83.0616 49.5048C85.3528 46.8656 85.0708 42.8687 82.4316 40.5775Z",
    stroke: "#555555",
    strokeWidth: 1.76484,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.09 31.2158L80.4746 42.2915",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4566 29.5776L77.0205 39.2948",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3472 35.5576L83.9111 45.2748",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33008 73.2375C2.33008 73.2375 15.3282 78.5964 23.3794 76.9028C31.4307 75.2092 31.3328 76.5722 33.8482 75.2478C36.3637 73.9234 41.8076 69.6728 45.0735 69.834C48.3395 69.9952 57.7904 68.2687 60.2003 68.3249C62.6101 68.381 69.4626 66.788 68.2526 62.5391C67.0426 58.2902 53.9502 58.6614 45.166 58.8772C36.3642 59.0852 33.2692 55.6834 33.2692 55.6834",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33008 73.2375C2.33008 73.2375 15.3282 78.5964 23.3794 76.9028C31.4307 75.2092 31.3328 76.5722 33.8482 75.2478C36.3637 73.9234 41.8076 69.6728 45.0735 69.834C48.3395 69.9952 57.7904 68.2687 60.2003 68.3249C62.6101 68.381 69.4626 66.788 68.2526 62.5391C67.0426 58.2902 53.9502 58.6614 45.166 58.8772C36.3642 59.0852 33.2692 55.6834 33.2692 55.6834",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9883 42.8672L44.1127 47.8974C44.1127 47.8974 42.705 56.8886 44.0078 58.597",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9883 42.8672L44.1127 47.8974C44.1127 47.8974 42.705 56.8886 44.0078 58.597",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1123 47.8981C44.1123 47.8981 48.6561 50.6801 52.7479 49.7786L54.9981 46.1543",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1123 47.8981C44.1123 47.8981 48.6561 50.6801 52.7479 49.7786L54.9981 46.1543",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7695 49.7861C52.7695 49.7861 54.712 53.448 59.829 55.4546L52.7695 49.7861Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7695 49.7861C52.7695 49.7861 54.712 53.448 59.829 55.4546",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8906 50.7369C43.8906 50.7369 46.2692 52.2904 47.907 52.3837C49.5449 52.4769 52.4212 53.4735 52.7078 54.2506C52.9945 55.0278 52.9299 58.6931 52.9299 58.6931",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8906 50.7369C43.8906 50.7369 46.2692 52.2904 47.907 52.3837C49.5449 52.4769 52.4212 53.4735 52.7078 54.2506C52.9945 55.0278 52.9299 58.6931 52.9299 58.6931",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0757 52.0443L52.7031 54.2508",
    stroke: "#555555",
    strokeWidth: 1.1798,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8468 49.9327C64.8468 49.9327 59.0894 44.1185 57.8118 42.4003C56.5343 40.6821 48.683 39.0219 43.8185 38.1553C38.954 37.2886 33.7359 34.6078 32.3263 34.6153C30.9168 34.6229 20.2959 37.7639 20.2959 37.7639",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.374 74.551C109.72 74.8965 110.28 74.8965 110.626 74.551L116.257 68.9198C116.602 68.5743 116.602 68.014 116.257 67.6684C115.911 67.3229 115.351 67.3229 115.005 67.6684L110 72.6739L104.995 67.6684C104.649 67.3229 104.089 67.3229 103.743 67.6684C103.398 68.014 103.398 68.5742 103.743 68.9198L109.374 74.551ZM110.626 24.0717C110.28 23.7261 109.72 23.7261 109.374 24.0717L103.743 29.7029C103.398 30.0484 103.398 30.6087 103.743 30.9542C104.089 31.2998 104.649 31.2998 104.995 30.9542L110 25.9487L115.005 30.9542C115.351 31.2998 115.911 31.2998 116.257 30.9542C116.602 30.6087 116.602 30.0484 116.257 29.7029L110.626 24.0717ZM110.885 73.9253V24.6974H109.115V73.9253H110.885Z",
    fill: "#F48474"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_4023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.509a73fcfb48134202da5481982d1498.svg";
export { ForwardRef as ReactComponent };